import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { ViewMore } from '@liveauctioneers/hammer-ui-core/viewMore';
import { memo } from 'react';

import PageTitle from '@/components/PageTitle/PageTitle';
import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogDescription,
    getCatalogSellerId,
    getCatalogTitle,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import { safelyRender } from '@/utils/safelyRender';

import { CatalogDetails } from '../Details/CatalogDetails';
import SellerInfo from '../SellerInfo/SellerInfo';

type Props = {
    catalogId: number;
    forceIsLive: boolean;
};

const { tabletNarrowWidthNum } = mergedCaterwaulAndHammerUIThemes.breakpoints;

const CatalogInfoComponent = ({ catalogId, forceIsLive }: Props) => {
    const description = useAppSelector((state) => getCatalogDescription(state, catalogId));
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));
    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const isMobile = useIsNarrowerThan(tabletNarrowWidthNum + 1);

    return (
        <div className="mr-sm flex flex-[1_1_calc(100%-290px)] flex-col bg-background-primary xsMax:m-0 xsMax:w-full xsMax:max-w-full xsMax:flex-[0_1_auto]">
            {!isMobile && (
                <CatalogDetails
                    catalogId={catalogId}
                    forceIsLive={forceIsLive}
                />
            )}
            <div className="[&_h1]:mb-sm [&_h1]:mt-lg [&_h1]:text-left xsMax:[&_h1]:text-center">
                <PageTitle title={title} />
            </div>
            <SellerInfo sellerId={sellerId} />
            {isMobile && (
                <CatalogDetails
                    catalogId={catalogId}
                    forceIsLive={forceIsLive}
                />
            )}
            <div className="mb-lg mr-sm xsMax:mr-0 xsMax:text-center">
                <ViewMore>
                    <BodyPrimary>{safelyRender({ html: description })}</BodyPrimary>
                </ViewMore>
            </div>
        </div>
    );
};

export default memo<Props>(CatalogInfoComponent);
